var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* Google Fonts */\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lexend:wght@100..900&display=swap\");\n\n/* Converted custom styles */\n.btn-primary {\n  padding: 0.5rem 0.75rem; /* px-3 py-2 */\n  background-color: #3c65f5;\n  color: white;\n  border-radius: 0.5rem; /* rounded-lg */\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  transition: background-color 0.2s ease-in-out;\n}\n\n.btn-primary:hover {\n  background-color: #3355d1;\n}\n\n.btn-primary:disabled {\n  cursor: not-allowed;\n  background-color: #f6f6f6;\n  color: #b4b4b4;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.btn-outline {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #4c4f59;\n  background-color: white;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.btn-outline:hover {\n  background-color: #f3f4f6; /* hover:bg-gray-100 */\n}\n\nbutton:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #3b82f6;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n\n.link:hover {\n  color: #3532eacc;\n  text-decoration: underline;\n}\n\ninput {\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.fade-slide-enter-active,\n.fade-slide-leave-active {\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n.fade-slide-enter-from,\n.fade-slide-leave-to {\n  opacity: 0;\n  transform: translateY(10px);\n}\n.fade-slide-leave-from,\n.fade-slide-enter-to {\n  opacity: 1;\n  transform: translateY(0);\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VerifyTransaction = require("./VerifyTransaction.vue");

var _VerifyTransaction2 = _interopRequireDefault(_VerifyTransaction);

var _CardStatementVerification = require("./CardStatementVerification.vue");

var _CardStatementVerification2 = _interopRequireDefault(_CardStatementVerification);

var _ProcessingVerification = require("./ProcessingVerification.vue");

var _ProcessingVerification2 = _interopRequireDefault(_ProcessingVerification);

var _CardCharged = require("./CardCharged.vue");

var _CardCharged2 = _interopRequireDefault(_CardCharged);

var _ConfirmVerification = require("./ConfirmVerification.vue");

var _ConfirmVerification2 = _interopRequireDefault(_ConfirmVerification);

var _VerificationSuccessful = require("./VerificationSuccessful.vue");

var _VerificationSuccessful2 = _interopRequireDefault(_VerificationSuccessful);

var _TransactionSuccessful = require("./TransactionSuccessful.vue");

var _TransactionSuccessful2 = _interopRequireDefault(_TransactionSuccessful);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    VerifyTransactions: _VerifyTransaction2.default,
    CardStatementVerification: _CardStatementVerification2.default,
    ProcessingVerification: _ProcessingVerification2.default,
    CardCharged: _CardCharged2.default,
    ConfirmVerification: _ConfirmVerification2.default,
    VerificationSuccessful: _VerificationSuccessful2.default,
    TransactionSuccessful: _TransactionSuccessful2.default
  },
  props: {
    gateway: {
      type: Object,
      required: true
    },
    amount_due: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    invoice_no: {
      type: String,
      required: true
    },
    base_url: {
      type: String,
      default: null
    },
    decision: {
      type: String,
      default: null
    },
    card_profile_id: {
      type: Number,
      default: null
    },
    callback_url: {
      type: String,
      default: null
    },
    wallet_token: {
      type: String,
      required: true,
      default: ""
    },
    pendingVerification: {
      type: Boolean

    }
  },
  data: function data() {
    return {
      step: null,
      amount: "0.00",
      loading: false,
      initPaymentResponse: null,
      showSuccessAlert: false,
      showErrorAlert: false,
      makePaymentError: null,
      verifyCodeError: null,
      proceedWithVerificationError: null,
      timeStamp: null,
      displayCardNumber: null
    };
  },
  mounted: function mounted() {
    this.checkDecision();
  },

  methods: {
    handleVoidProfileVerification: async function handleVoidProfileVerification() {
      var _this = this;

      this.step = 0;
      await Vue.axios.post(this.base_url + this.gateway.configs.cs_void_verifications_url, { ref: this.invoice_no }, this.getAuthHeaders()).then(function (response) {
        if (response.data.message === "success") {
          _this.pendingVerification = false;
          _this.$emit("revokePendingVerification");
        }
      }).catch(function (error) {});
    },
    handleCancel: function handleCancel() {
      location.reload();
    },
    checkInitialStep: function checkInitialStep() {
      if (this.pendingVerification) {
        this.step = 5;
      } else {
        this.step = 2;
      }
    },
    getAuthHeaders: function getAuthHeaders() {
      return {
        headers: {
          Authorization: "Bearer " + this.wallet_token,
          "Content-Type": "application/json"
        }
      };
    },
    handleConfirmVerification: function handleConfirmVerification() {
      this.step = 5;
    },
    handleTryDifferentCard: function handleTryDifferentCard() {
      this.step = 0;
      this.$emit("tryAnotherCard");
    },
    checkDecision: async function checkDecision() {
      if (this.decision === "approve") {
        this.step = 1;
        var directCaptureUrl = this.base_url + this.gateway.configs.cs_capture_url;
        var directCaptureParams = {
          card_profile: this.card_profile_id
        };
        try {
          var directCaptureResponse = await Vue.axios.post(directCaptureUrl, directCaptureParams, this.getAuthHeaders());
          if (directCaptureResponse.data.message === "success") {
            this.step = 7;
          } else {
            this.makePaymentError = "Error while making payment.";
            this.step = 0;
            this.$emit("addError", "Payment Could Not Be Processed");
          }
        } catch (error) {
          this.makePaymentError = "Error while making payment.";
        }
      } else {
        this.checkInitialStep();
      }
    },
    handleCodeVerification: async function handleCodeVerification(data) {

      if (data.isMaxAttemptsReached) {

        return;
      }
      var verifyUrl = this.base_url + this.gateway.configs.cs_verify_url;
      var verifyParams = {
        code: data.code,
        reference: this.invoice_no,
        card_profile: this.card_profile_id
      };
      try {
        var verifyCodeData = await Vue.axios.post(verifyUrl, verifyParams, this.getAuthHeaders());
        if (verifyCodeData.data.message === "verified") {
          this.showSuccessAlert = true;
          this.step = 6;

          var directCaptureUrl = this.base_url + this.gateway.configs.cs_capture_url;
          var directCaptureParams = {
            card_profile: this.card_profile_id
          };
          try {
            var directCaptureResponse = await Vue.axios.post(directCaptureUrl, directCaptureParams, this.getAuthHeaders());
            if (directCaptureResponse.data.message === "success") {
              this.step = 7;
            } else {
              this.verifyCodeError = "Error while verifying code.";
              this.step = 0;
              this.$emit("addError", "Payment Could Not Be Processed");
            }
          } catch (error) {
            this.verifyCodeError = "Error while verifying code.";
          }
        } else {
          this.showErrorAlert = true;
        }
      } catch (error) {}
    },
    handleProceedWithVerification: async function handleProceedWithVerification() {
      var handle_transaction_url = this.base_url + this.gateway.configs.cs_transaction_url;
      this.step = 3;

      var handle_transaction_params = {
        card_profile: this.card_profile_id
      };

      try {
        var verifyResponse = await Vue.axios.post(handle_transaction_url, handle_transaction_params, this.getAuthHeaders());
        if (verifyResponse.data.message === "Not Valid") {
          this.step = 0;
          this.$emit("addError", "Verification Unsuccessful");
        } else {
          this.timeStamp = verifyResponse.data.details.timestamp;
          this.displayCardNumber = verifyResponse.data.details.card_no;
          this.step = 4;
        }
      } catch (error) {
        this.step = 0;
        this.$emit("addError", "Verification Unsuccessful");
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex flex-col gap-6 justify-between h-full overflow-hidden"},[_c('Transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c('div',{key:_vm.step},[(_vm.step === 1)?_c('VerifyTransactions'):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('CardStatementVerification',{on:{"proceedWithVerification":_vm.handleProceedWithVerification,"try-different-card":_vm.handleTryDifferentCard}}):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('ProcessingVerification'):_vm._e(),_vm._v(" "),(_vm.step === 4)?_c('CardCharged',{attrs:{"timestamp":_vm.timeStamp,"displayCardNumber":_vm.displayCardNumber},on:{"comeBackLater":_vm.handleCancel,"ConfirmVerification":_vm.handleConfirmVerification,"try-different-card":_vm.handleTryDifferentCard}}):_vm._e(),_vm._v(" "),(_vm.step === 5)?_c('ConfirmVerification',{attrs:{"showSuccessAlert":_vm.showSuccessAlert,"showErrorAlert":_vm.showErrorAlert,"maxAttempts":3,"pendingVerification":_vm.pendingVerification},on:{"codeVerification":_vm.handleCodeVerification,"try-different-card":_vm.handleTryDifferentCard,"comeBackLater":_vm.handleCancel,"voidProfileVerification":_vm.handleVoidProfileVerification}}):_vm._e(),_vm._v(" "),(_vm.step === 6)?_c('VerificationSuccessful'):_vm._e(),_vm._v(" "),(_vm.step === 7)?_c('TransactionSuccessful',{attrs:{"callback_url":_vm.callback_url}}):_vm._e()],1)])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c165b072", __vue__options__)
  } else {
    hotAPI.reload("data-v-c165b072", __vue__options__)
  }
})()}